export default {
  //Used for Success, MagicLink, Provider, etc.
  sign_in: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-30",
    container:
      "w-full md:w-[755px] h-full md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper md:rounded-[24px] py-8",
    header: "relative flex justify-between items-center px-10 mb-0",
    closeButton: "absolute right-6 md:right-8 top-1 z-20",
    closeIcon: "h-7 w-7 text-gray_2 hover:text-gray_1",
    title:
      "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text text-center md:text-left leading-tight mt-[100px] mb-0 md:my-0",
    headerContent: "flex items-center",
    contentWrapper:
      "w-full max-h-[calc(100vh-10rem)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray_3 scrollbar-track-paper px-4",
    content: "w-full md:px-6 md:py-4",
  },

  default: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "w-full max-h-full md:max-h-[calc(100vh-2rem)] bg-paper md:rounded-lg border border-bordered shadow-lg overflow-hidden",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 hover:text-white z-20",
    closeIcon: "h-7 w-7 text-text_secondary hover:text-text",
    title: "flex-1 text-lg font-bold text-text mt-[2px]",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper max-h-[calc(100vh-4rem)]",
    content: "px-4 pb-4 sm:px-5 sm:pb-5",
    footer: "border-t border-bordered bg-paper px-4 py-4 sm:px-5 sm:py-5",
  },

  // Admin analogue of "default"
  admin: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "w-full max-h-full md:max-h-[calc(100vh-2rem)] bg-admin_paper md:rounded-lg border border-admin_bordered shadow-lg overflow-hidden",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 hover:text-white z-20",
    closeIcon: "h-7 w-7 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-lg font-bold text-admin_text mt-[2px]",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper max-h-[calc(100vh-4rem)]",
    content: "px-4 pb-4 sm:px-5 sm:pb-5",
    footer: "border-t border-admin_bordered bg-admin_paper px-4 py-4 sm:px-5 sm:py-5",
  },

  compact: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "bg-paper max-h-full md:max-h-[calc(80vh)] overflow-y-auto md:rounded-md border border-bordered shadow-lg w-full max-w-[50%] p-0 m-0",
    header: "relative flex justify-between items-center p-3",
    closeButton: "absolute right-3 top-3 hover:text-white z-20",
    closeIcon: "h-5 w-5 text-text_secondary hover:text-text",
    title: "flex-1 text-base font-bold text-text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "pb-3 sm:pb-4",
  },

  // Admin analogue of "compact"
  admin_compact: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "bg-admin_paper max-h-full md:max-h-[calc(80vh)] scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper overflow-y-auto md:rounded-md border border-admin_bordered shadow-lg w-full max-w-[50%] p-0 m-0",
    header: "relative flex justify-between items-center p-3",
    closeButton: "absolute right-3 top-3 hover:text-white z-20",
    closeIcon: "h-5 w-5 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-base font-bold text-admin_text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "pb-3  sm:pb-4",
  },

  //the content is not scrollable
  compact_fixed: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "bg-paper max-h-full md:max-h-[calc(80vh)] overflow-hidden md:rounded-md border border-bordered shadow-lg w-full max-w-[50%] p-0 m-0",
    header: "relative flex justify-between items-center p-3",
    closeButton: "absolute right-3 top-3 hover:text-white z-20",
    closeIcon: "h-5 w-5 text-text_secondary hover:text-text",
    title: "flex-1 text-base font-bold text-text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "pb-3  sm:pb-4",
  },

  // Admin compact that shrinks to fit content width
  admin_compact_fit: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "bg-admin_paper max-h-full md:max-h-[calc(80vh)] scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper overflow-y-auto md:rounded-md border border-admin_bordered shadow-lg w-fit p-0 m-0",
    header: "relative flex justify-between items-center p-3",
    closeButton: "absolute right-3 top-3 hover:text-white z-20",
    closeIcon: "h-5 w-5 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-base font-bold text-admin_text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "pb-3 sm:pb-4",
  },

  // Admin analogue of "compact_fixed"
  admin_compact_fixed: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "bg-admin_paper max-h-full md:max-h-[calc(80vh)] overflow-hidden md:rounded-md border border-admin_bordered shadow-lg w-full max-w-[50%] p-0 m-0",
    header: "relative flex justify-between items-center p-3",
    closeButton: "absolute right-3 top-3 hover:text-white z-20",
    closeIcon: "h-5 w-5 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-base font-bold text-admin_text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "pb-3  sm:pb-4",
  },

  centered: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "w-full md:max-w-2xl h-full md:h-auto max-h-full md:max-h-[calc(100vh-4rem)] bg-paper overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper md:rounded-lg border border-bordered shadow-xl md:mx-4",
    header: "relative flex justify-between items-center p-5",
    closeButton: "absolute right-5 top-5 hover:text-white z-20",
    closeIcon: "h-7 w-7 text-text_secondary hover:text-text",
    title: "flex-1 text-xl md:text-xl font-bold text-text md:mr-8 mt-14 md:mt-0",
    headerContent: "flex items-center",
    contentWrapper: "",
    content: "px-5 py-5 md:px-6 sm:pb-6 md:pt-3",
  },

  // Admin analogue of "centered"
  admin_centered: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50",
    container:
      "w-full max-w-2xl max-h-full md:max-h-[calc(100vh-4rem)] bg-admin_paper overflow-y-auto scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper md:rounded-lg border border-admin_bordered shadow-xl mx-4",
    header: "relative flex justify-between items-center p-5",
    closeButton: "absolute right-5 top-1/2 -translate-y-1/2 hover:text-white z-20",
    closeIcon: "h-7 w-7 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-xl font-bold text-admin_text",
    headerContent: "flex items-center",
    contentWrapper: "",
    content: "px-5 py-5 sm:px-6 sm:py-6",
    footer: "border-t border-admin_bordered bg-admin_paper px-5 py-5 sm:px-6 sm:py-6",
  },

  fullScreen: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-90 z-50",
    container: "bg-paper w-full h-full overflow-y-auto", // Changed from overflow-hidden
    header: "relative flex justify-between items-center p-4 md:p-6",
    closeButton:
      "absolute right-4 md:right-6 top-4 md:top-6 hover:text-white z-20",
    closeIcon: "h-8 w-8 text-text_secondary hover:text-text",
    title: "flex-1 text-xl md:text-2xl font-bold text-text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto h-[calc(100vh-80px)] scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper", // Changed from overflow-hidden
    content: "px-4 pb-4 md:px-6 md:pb-6",
  },

  // Admin analogue of "fullScreen"
  admin_fullScreen: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-90 z-50",
    container: "bg-admin_paper w-full h-full overflow-y-auto", // Changed from overflow-hidden
    header: "relative flex justify-between items-center p-4 md:p-6",
    closeButton:
      "absolute right-4 md:right-6 top-4 md:top-6 hover:text-white z-20",
    closeIcon: "h-8 w-8 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-xl md:text-2xl font-bold text-admin_text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto h-[calc(100vh-80px)] scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper", // Changed from overflow-hidden
    content: "px-4 pb-4 md:px-6 md:pb-6",
  },

  // Right drawer - slides in from the right side
  drawer_right: {
    animation: {
      open:  { initial: { x: "100%" }, animate: { x: 0 },      transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { x: "100%" },                          transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex justify-end bg-black bg-opacity-30 z-50",
    container:
      "w-full h-full max-w-2xl flex flex-col bg-paper",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute left-4 top-4 z-20",
    closeIcon: "h-6 w-6 text-text_secondary hover:text-text",
    title: "flex-1 text-lg font-bold text-text text-center",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto h-[calc(100%-65px)] scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper",
    content: "",
  },

  // Admin analogue of "drawer_right"
  admin_drawer_right: {
    animation: {
      open:  { initial: { x: "100%" }, animate: { x: 0 },      transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { x: "100%" },                          transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex justify-end bg-black bg-opacity-30 z-50",
    container:
      "w-full h-full max-w-2xl flex flex-col bg-admin_paper",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute left-4 top-4 z-20",
    closeIcon: "h-6 w-6 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-lg font-bold text-admin_text text-center",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto h-[calc(100%-65px)] scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper",
    content: "",
  },

  // Left drawer - slides in from the left side
  drawer_left: {
    animation: {
      open:  { initial: { x: "-100%" }, animate: { x: 0 },     transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { x: "-100%" },                         transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex justify-start bg-black bg-opacity-30 z-50",
    container:
      "w-full h-full max-w-2xl flex flex-col bg-paper",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 z-20",
    closeIcon: "h-6 w-6 text-text_secondary hover:text-text",
    title: "flex-1 text-lg font-bold text-text text-center",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto h-[calc(100%-65px)] scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper",
    content: "",
  },

  // Admin analogue of "drawer_left"
  admin_drawer_left: {
    animation: {
      open:  { initial: { x: "-100%" }, animate: { x: 0 },     transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { x: "-100%" },                         transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex justify-start bg-black bg-opacity-30 z-50",
    container:
      "w-full h-full max-w-2xl flex flex-col bg-admin_paper",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 z-20",
    closeIcon: "h-6 w-6 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-lg font-bold text-admin_text text-center",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto h-[calc(100%-65px)] scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper",
    content: "",
  },

  // Top drawer - slides in from the top
  drawer_top: {
    animation: {
      open:  { initial: { y: "-100%" }, animate: { y: 0 },     transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { y: "-100%" },                         transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex flex-col justify-start items-center bg-black bg-opacity-70 z-50",
    container: "bg-paper w-full shadow-lg overflow-y-auto max-h-[80vh]",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 hover:text-white z-20",
    closeIcon: "h-6 w-6 text-text_secondary hover:text-text",
    title: "flex-1 text-lg font-bold text-text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "px-4 py-4",
  },

  // Admin analogue of "drawer_top"
  admin_drawer_top: {
    animation: {
      open:  { initial: { y: "-100%" }, animate: { y: 0 },     transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { y: "-100%" },                         transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex flex-col justify-start items-center bg-black bg-opacity-70 z-50",
    container: "bg-admin_paper w-full shadow-lg overflow-y-auto max-h-[80vh]",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 hover:text-white z-20",
    closeIcon: "h-6 w-6 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-lg font-bold text-admin_text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "px-4 py-4",
  },

  // Bottom drawer - slides in from the bottom
  drawer_bottom: {
    animation: {
      open:  { initial: { y: "100%" }, animate: { y: 0 },      transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { y: "100%" },                          transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex flex-col justify-end items-center bg-black bg-opacity-70 z-50",
    container: "bg-paper w-full shadow-lg overflow-y-auto max-h-[80vh]",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 hover:text-white z-20",
    closeIcon: "h-6 w-6 text-text_secondary hover:text-text",
    title: "flex-1 text-lg font-bold text-text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "px-4 py-4",
  },

  admin_drawer_bottom: {
    animation: {
      open:  { initial: { y: "100%" }, animate: { y: 0 },      transition: { ease: "easeInOut", duration: 0.3 } },
      close: { exit:    { y: "100%" },                          transition: { ease: "easeInOut", duration: 0.3 } },
    },
    overlay:
      "fixed top-0 left-0 w-full h-full flex flex-col justify-end items-center bg-black bg-opacity-70 z-50",
    container: "bg-admin_paper w-full shadow-lg overflow-y-auto max-h-[80vh]",
    header: "relative flex justify-between items-center p-4",
    closeButton: "absolute right-4 top-4 hover:text-white z-20",
    closeIcon: "h-6 w-6 text-admin_text_secondary hover:text-admin_text",
    title: "flex-1 text-lg font-bold text-admin_text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-hidden",
    content: "px-4 py-4",
  },

  store_checkout: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-30",
    container:
      "w-full h-[100dvh] md:w-[755px] md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper overflow-hidden md:rounded-[24px] p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] flex flex-col",
    header: "relative flex justify-between items-center",
    closeButton: "absolute right-4 top-4 z-20",
    closeIcon: "h-7 w-7 text-gray_2 hover:text-gray_1",
    title: "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text leading-tight my-0",
    headerContent: "flex items-center",
    contentWrapper: "w-full h-full flex-1 min-h-0",
    content: "w-full h-full",
  },

  // Mobile full-screen bottom-sheet for in-call controls
  meet_mobile: {
    animation: {
      open:  { initial: { y: "100%" }, animate: { y: 0 }, transition: { type: "spring", damping: 30, stiffness: 320 } },
      close: { exit:    { y: "100%" },                    transition: { duration: 0.2, ease: "easeIn" } },
    },
    overlay: "fixed inset-0 flex flex-col justify-end bg-black/60 z-50",
    container: "w-full bg-gray-900 rounded-t-2xl shadow-2xl overflow-hidden flex flex-col",
    header: "relative flex justify-center items-center pt-3 pb-0 flex-shrink-0",
    closeButton: "absolute right-4 top-3 z-20",
    closeIcon: "h-6 w-6 text-gray-400 hover:text-white",
    title: "",
    headerContent: "",
    contentWrapper: "overflow-y-auto",
    content: "px-0 pb-safe",
  },

  // Right-side drawer panel for in-call overlays (host controls, etc.)
  meet_drawer: {
    overlay: "fixed inset-0 flex items-stretch justify-end",
    container: "w-full md:max-w-sm bg-gray-900 border-l border-gray-700 shadow-2xl flex flex-col",
    header: "relative flex flex-col px-5 pt-5 pb-4 border-b border-gray-700 flex-shrink-0",
    closeButton: "absolute right-4 top-4 z-20",
    closeIcon: "h-5 w-5 text-gray-400 hover:text-white",
    title: "text-base font-semibold text-white pr-8",
    headerContent: "mt-1",
    contentWrapper: "flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-900",
    content: "p-0",
    animation: {
      open: {
        initial: { x: "100%" },
        animate: { x: 0 },
        transition: { type: "spring", damping: 28, stiffness: 300 },
      },
      close: {
        exit: { x: "100%" },
        transition: { duration: 0.2, ease: "easeIn" },
      },
    },
  },
}
